export interface NewTicketResponse {
  msg: string;
  data: Data;
}

interface Data {
  case: Case;
}

export interface Case {
  Id: string;
  CaseNumber: string;
  attributes: Attribute;
  Dispositions__c: string;
  Interaction_Reason__c: string;
}

interface Attribute {
  type: string;
  url: string;
}

export interface CaseEvent {
  Id: string;
  CaseNumber: string;
}